import api from '../../utils/api';

export const updatePropertyUnitStatuses = (variables: any) =>
  api.put({
    url: `/property/${variables.id}/unit-statuses`,
    variables: variables.colors.map((v: any) => ({ unitStatusId: v.id, color: v.color })),
  });
